import React from "react"
import Button from "@/components/core/Button/Button"
import styles from "./index.module.scss"
import { thankYouAnalytics } from "../v1/checkoutAnalytics"

const ConfirmationModal = ({
  staticTexts,
  handleModalClose,
  isOmnichannel = false,
}) => {
  const onClick = () => {
    handleModalClose()
    if (!isOmnichannel) thankYouAnalytics()
  }

  return (
    <div className={styles.confirmationModal}>
      <div className="confirmationModal-body">
        {staticTexts.confirmationmodal}
      </div>
      <Button
        customClass="quantity-modal__button"
        label={"Close"}
        tag="button"
        flexible
        type="black"
        onClick={onClick}
      />
    </div>
  )
}
export default ConfirmationModal
